// ONE gender-agreement door for "<category plural> <adjective>" (INCIDENT 15/10/26: "חברות מבנים יבילים מובילים בישראל" - a hardcoded
// masculine adjective on a feminine head noun). The adjective must agree with the HEAD noun (first word) of the plural phrase:
// feminine head (…ות: חברות, מדריכות, דיאטניות, מזכירות) -> feminine adjective; everything else (…ים, construct …י, "מומחים ל…") -> masculine.
// Pass the MASCULINE plural adjective ("מובילים", "מומלצים", "מדורגים", "המדורגים"); get it back agreed.
// Shared by lib/categoryPlural.ts, components, scripts/x3d-journey-router.mjs and the gate scripts/qa/hebrew-heading-gender-audit.mjs.
const MASC_OT = new Set(["אולמות"]); // masculine nouns that end in ות
export function isFemininePluralPhrase(plural) {
  const head = String(plural || "").trim().split(/\s+/)[0] || "";
  return /ות$/.test(head) && !MASC_OT.has(head);
}
export function agreeAdjPlural(plural, mascAdj) {
  if (!isFemininePluralPhrase(plural)) return mascAdj;
  return String(mascAdj).replace(/ים$/, "ות");
}
